export const newSubscribers = [
    {month: 'Jan', count: 1000},
    {month: 'Feb', count: 500},
    {month: 'Mar', count: 1300},
    {month: 'Apr', count: 300},
    {month: 'May', count: 750},
    {month: 'Jun', count: 850},
    {month: 'Jul', count: 150},
];
